import { render, staticRenderFns } from "./UiListData.vue?vue&type=template&id=0d8ba5ec&scoped=true"
import script from "./UiListData.vue?vue&type=script&lang=js"
export * from "./UiListData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ba5ec",
  null
  
)

export default component.exports